export default __webpack_public_path__ + "static/media/pic3.489dbaf3.jpg";